import { render, staticRenderFns } from "./DeleteCard.vue?vue&type=template&id=85c97036&scoped=true"
import script from "./DeleteCard.vue?vue&type=script&lang=js"
export * from "./DeleteCard.vue?vue&type=script&lang=js"
import style0 from "./DeleteCard.vue?vue&type=style&index=0&id=85c97036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c97036",
  null
  
)

export default component.exports